import {useState} from "react";
import styled from 'styled-components/macro';

import {
    Button,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay
} from "@chakra-ui/react";
import {useDeletePostFlair, useFlairs, useSetPostFlair} from "../api/flairs";
import {useFeedback} from "../store/feedback";
import {useActions} from "../store";
import Spinner from "./spinner";
import {useStoreCommunity} from "../store/hooks";

const Item = styled.div`
  width: 48%;
  white-space: nowrap;
  overflow: hidden;
  margin-bottom: 8px;
  &:first-of-type {
    margin-top: 0;
  }
  svg {
    margin-right: 16px;
    font-size: 26px;
  }`;
const Flairs = styled.div`
  max-height: 400px;
  overflow-y: scroll;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  input[type="radio"] {
    visibility: hidden;
    width: 0;
  }
  input[type="radio"]:checked + label {
    font-weight: 500;
  }`;
const Preview = styled.div``;

const FlairPost = styled(({className, post, onClose}) => {
    const hasCurrentFlair = post.post_flair_text;
    const actions = useActions();
    const loading = useFeedback();
    const flairs = useFlairs(loading.channel, post.community, "post");
    const [customText, setCustomText] = useState();
    const [flairSelection, setFlairSelection] = useState();
    const saving = useFeedback();
    const setPostFlair = useSetPostFlair(saving.channel);
    const deletePostFlair = useDeletePostFlair(saving.channel);
    const community = useStoreCommunity(post.community);
    const handleFlair = async () => {
        const flair = flairSelection || {text: "", class: ""};
        const action = actions.postFlairChanged(post.id, customText || flair.text, flair.class);
        onClose();
        try {
            if (flairSelection) {
                await setPostFlair(post.id, customText || flairSelection.text, flairSelection.class);
            } else {
                await deletePostFlair(post.id);
            }
        } catch {
            action.undo();
        }
    };
    const handleClose = async () => {
        if (hasCurrentFlair) {
            actions.postFlairChanged(post.id, '', '');
            await deletePostFlair(post.id);
            onClose();
        } else {
            onClose();
        }
    };
    const handleSelection = async (flair) => {
        setFlairSelection(flair);
        setCustomText(flair.text);
    };
    return (
        <Modal
            isOpen
            onClose={onClose}
            size={'lg'}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Set Post Flair</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6} className={className}>
                    <Flairs>
                        {loading.busy && <Spinner/>}
                        {flairs?.map((flair) => (
                            <Item key={flair.class}>
                                <input id={`flair_${flair.class}_${flair.text}`} type="radio" name="flair" onChange={() => handleSelection(flair)} />
                                <label htmlFor={`flair_${flair.class}_${flair.text}`} className='post-flair' data-flair={flair.class}>
                                    {flair.text}
                                </label>
                            </Item>
                        ))}
                    </Flairs>
                    {flairSelection &&
                        <Preview>
                            <p>{community.is_moderator ? 'Edit Flair' : 'Preview'}</p>
                            {community.is_moderator &&
                                <Input value={customText} style={{marginBottom: '16px'}}
                                       onChange={(e) => setCustomText(e.currentTarget.value)}/>
                            }
                            <Item key={flairSelection.class}>
                                <label htmlFor={`flair_${flairSelection.class}`} className='post-flair' data-flair={flairSelection.class}>
                                    {customText || flairSelection.text}
                                </label>
                            </Item>
                        </Preview>
                    }
                </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={handleClose}>{hasCurrentFlair ? 'Remove' : 'Cancel'}</Button>
                    <Button variant="blue" onClick={handleFlair}>
                        Save
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )})`
    
  ${Preview} {
    padding-top: 12px;
    margin-top: 12px;
    border-top: ${({theme}) => theme.color.name === 'dark' ? '1px solid #343536' : '1px solid #f2f2f2'};
  }
${Preview} p {
  font-weight: 500;
  font-size: 16px;
  padding-bottom: 8px;
}
`;

export default FlairPost;
